import * as React from 'react';
import { styled } from '@glitz/react';
import {
  createMaxMobileViewportDecorator,
  createMaxSmallViewportDecorator,
  createMinLargeViewportDecorator,
} from 'webapp/viewport';
import { ProductListingCard } from './ProductListingCard';
import { edgeMarginsDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { translate } from '@avensia/excite';
import { isSvenssons } from 'webapp/theme';

export const ProductListingSearchListing = styled(
  ({ list }: { list: NordicNest.Api.SearchResultPageItemApiModel[] }) => {
    return (
      <Base>
        {isSvenssons && <Count>{translate(t => t.productListing.hits, { hits: list.length })}</Count>}
        <Grid>
          {list.map((plp, i) => (
            <ProductListingCard key={i} {...plp} />
          ))}
        </Grid>
      </Base>
    );
  },
);

const Base = styled.div(
  maxContentNormalWidthDecorator,
  edgeMarginsDecorator,
  createMinLargeViewportDecorator({
    padding: { x: t => t.spacing.xxxl },
  }),
);

const Grid = styled.div(
  createMinLargeViewportDecorator({
    gridRowGap: t => t.sharedSpacing.xl,
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  }),
  createMaxMobileViewportDecorator({
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gridColumnGap: t => t.sharedSpacing.m,
    gridRowGap: t => t.sharedSpacing.m,
  }),
  {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gridColumnGap: t => t.sharedSpacing.l,
    gridRowGap: t => t.sharedSpacing.l,
  },
);

const Count = styled.div(
  createMaxMobileViewportDecorator({
    textAlign: 'center',
  }),
  createMaxSmallViewportDecorator({
    padding: { x: t => t.sharedSpacing.m },
  }),
  {
    textAlign: 'right',
    fontSize: t => t.fontSize.xxs,
    marginBottom: t => t.sharedSpacing.xs,
  },
);
